
<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">
      
      <AppFilter 
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" />

      <AppFilterDateRange
        ref="dateRangeFilter"
        v-show="showCalendar"
        v-on:filter-data-change="onFilterDateChange" />

      <button v-show="showExportCSV" v-on:click="onCSVButtonClick" type="button" class="btn btn-warning">
        Export CSV
      </button>

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"/>

      <TemplateFeedback class="m-t" ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppFilterDateRange from "@/components/App/AppFilterDateRange";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');
var moment = require('moment');

let PARAM = [
  {
    key: 'customer',
    text: 'Account Holder',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(!dataItem.customerID) {
        return '';
      }
      if(dataItem.isCompany) {
        return `<a target="_blank" href="${helper.WEB_URL}/companyForm?customerID=${dataItem.customerID}">${dataItem.customer}</a>`;
      } else {
        return `<a target="_blank" href="${helper.WEB_URL}/personalForm?customerID=${dataItem.customerID}">${dataItem.customer}</a>`;
      }
    },
  },
  {
    key: 'parkinglicense',
    text: 'Parking License',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a target="_blank" href="${helper.WEB_URL}/parkinglicenseView?licenseID=${dataItem.licenseID}">${dataItem.parkinglicense}</a>`;
    },
  },
  {
    key: 'parker',
    text: 'No. of Parker',
  },
  {
    key: 'orNum',
    text: 'OR No.',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a href="billOR?orID=${dataItem.id}" target="_blank">${dataItem.orNum}</a>`;
    },
  },
  {
    key: 'orDate',
    text: 'OR Date',
  },
  {
    key: 'paymentType',
    text: 'Payment Type',
  },
  {
    key: 'deposit',
    text: 'Deposit',
  },
  {
    key: 'estbFee',
    text: 'Establishment Fee',
  },
  {
    key: 'parkingFee',
    text: 'Parking Fee',
  },
  {
    key: 'total',
    text: 'Total',
  },
];
const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageReportCarParkCollection",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
    AppFilterDateRange,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Report' },
        { name: 'Car Park Collection' },
      ],

      PARAM,
      PARAM_MAP,

      pageStaff: [],
      pagePaymentMethod: [],
      pageCarpark: null,
      pageCustomer: null,
      pageBill: null,
      pageSeasonFees: {},
      pageReport: null,

      showExportCSV: false,
      showCalendar: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.$refs['dateRangeFilter'].filterDateStart = moment().startOf('month');
    this.$refs['dateRangeFilter'].filterDateEnd = moment().endOf('month');
    this.loadCarpark();
  },
  methods: {
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          this.showCalendar = true;
          this.loadSeason();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadSeason() {
      let feedbackItem = 'car park product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/season/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageSeason = response.data;
            this.loadCustomer();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCustomer() {
      let feedbackItem = 'customer data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      // if(this.$refs['carparkFilter'].filterValue) {
      //   url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      // }
      url += '/customer/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageCustomer = response.data;
            this.loadLicense();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLicense() {
      let feedbackItem = 'license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '/carpark/' + this.$refs['carparkFilter'].filterValue;
      }
      url += '/license/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageLicense = response.data;
            this.loadCollection();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCollection() {
      let startDate = this.$refs['dateRangeFilter'].filterDateStart;
      let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

      this.$refs['pageTable'].setTableData(null);
      
      let feedbackItem = 'collection data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/collection?1=1';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
      }

      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');

          response.data = response.data.filter(k => {
            if(this.$refs['carparkFilter'].filterValue) {
              if(!helper.compareID(k.carparkID, this.$refs['carparkFilter'].filterValue)) {
                return false;
              }
            }
            return true;
          });
          
          let temp = {};
          // response.data = response.data.filter(k => {
          //   if(!k.paidDate) {
          //     return false;
          //   }
          //   if(k.paidDate < startDate.unix()) {
          //     return false;
          //   }
          //   if(k.paidDate > endDate.unix()) {
          //     return false;
          //   }
          //   return true;
          // })
          response.data.forEach(k => {
            let type = k['type'];
            if(type.endsWith('INV')) {
              k['_type'] = 'invoice';
            } else if(type.endsWith('CN')) {
              k['_type'] = 'creditNote';
            } else if(type.endsWith('DN')) {
              k['_type'] = 'debitNote';
            }

            try {
              k['_dataRef'] = JSON.parse(k['dataRef']);
            } catch(e) {              
            }

            k['_license'] = this.pageLicense.find(j => j.carparkID === k.carparkID && j.customerID === k.customerID);
            k['licenseID'] = k['_license']['id'];
            k['_licenseStatus'] = k['_license']['status'];
            k['_licenseNum'] = k['_license']['licenseOperatorNum'];
            k['_carparkNum'] = k['_license']['carparkID'];
            k['_carpark'] = this.pageCarpark.find(j => j.id === k['carparkID']) || {};
            k['_carparkName'] = (k['_carpark'] || {}).name;
            k['_customer'] = this.pageCustomer.find(j => j.id === k['customerID']) || {};
            k['isCompany'] = (k['_customer'] || {}).isCompany;
            k['_customerType'] = (k['_customer'] || {}).isCompany ? 'Company' : 'Personal';

            let collectionID = k['id'];
            temp[collectionID] = temp[collectionID] || k;
            temp[collectionID]._invoice = temp[collectionID]._invoice || [];
            temp[collectionID]._invoice.push(k);
            temp[collectionID]['paymentType'] = k['paymentType'];
          });

          this.pageCollection = Object.keys(temp).map(k => temp[k]);

          this.loadOR();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadOR() {
      let startDate = this.$refs['dateRangeFilter'].filterDateStart;
      let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

      let feedbackItem = 'official receipt data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2/receipt?1=1';
      if(this.$refs['carparkFilter'].filterValue) {
        url += '&carparkID=' + this.$refs['carparkFilter'].filterValue;
      }
      // url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      // url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());
      url += '&sort=createDate';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');

          // // TODO OR doesn't have carparkID, recover this after fix
          // response.data = response.data.filter(k => {
          //   if(this.$refs['carparkFilter'].filterValue) {
          //     if(!helper.compareID(k.carparkID, this.$refs['carparkFilter'].filterValue)) {
          //       return false;
          //     }
          //   }
          //   if(this.$refs['licenseFilter'].filterValue) {
          //     let license = this.pageLicense.find(k => helper.compareID(k.id, this.$refs['licenseFilter'].filterValue));
          //     if(!helper.compareID(k.customerID, license.customerID)) {
          //       return false;
          //     }
          //   }
          //   return true;
          // });
          
          let temp = {};
          response.data = response.data.filter(k => {
            if(!k.createDate) {
              return false;
            }
            if(k.createDate < startDate.unix()) {
              return false;
            }
            if(k.createDate > endDate.unix()) {
              return false;
            }

            k['_collection'] = this.pageCollection.find(j => j.id === k['collectionID']);

            if(!k['_collection']) return false;

            k['paymentType'] = k['_collection']['paymentType'];
            k['carparkID'] = k['_collection']['carparkID'];
            if(this.$refs['carparkFilter'].filterValue) {
              if(!helper.compareID(k.carparkID, this.$refs['carparkFilter'].filterValue)) {
                return false;
              }
            }
            return true;
          })

          this.pageOR = response.data;
          this.processReport();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    async processReport() {
      let result = [];

      for(let index in this.pageOR) {
        let k = this.pageOR[index];
        let temp = k;

        temp['parker'] = 0;
        temp['deposit'] = 0;
        temp['estbFee'] = 0;
        temp['parkingFee'] = 0
        temp['total'] = 0;
        let parkerList = [];

        for(let collectionInvoices of k['_collection']['_invoice']) {
          let feedbackItem = 'invoice detail'
          this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
          collectionInvoices['invoiceLease'] = await this.$http
            .get(
              helper.SERVER_URL + '/api2/invoiceLease/?invoiceID=' + collectionInvoices['invoiceID'],
              helper.createAxiosConfig()
            )
            .then(response => {
              let resultMeta = helper.processAxiosResponse(this, response);
              if(response.data && response.data.length > 0) {
                this.$refs['pageFeedback'].setFeedbackMessage();
                return response.data;
              } else {
                this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
              }
            })
            .catch(error => {
              this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
            })
          
          if(!collectionInvoices['invoiceLease']) {
            if(window.location.href.includes('localhost')) {
              collectionInvoices['invoiceLease'] = [];
            } else {
              return;
            }
          }

          for(let invoiceRecord of collectionInvoices['invoiceLease']) {
            // let userIdentifier = invoiceRecord['userID'];
            let userIdentifier = invoiceRecord['leaseID'];
            if(!parkerList.includes(userIdentifier)) {
              parkerList.push(userIdentifier);
              temp['parker']++;
            }
            if(invoiceRecord['type'] === 'Deposit INV') {
              temp['deposit'] += invoiceRecord.inclusive;
            } else if(invoiceRecord['type'] === 'ESTB Fee INV') {
              temp['estbFee'] += invoiceRecord.inclusive;
            } else if(invoiceRecord['type'] === 'INIT Fee INV') {
              temp['parkingFee'] += invoiceRecord.inclusive;
            } else if(invoiceRecord['type'] === 'Monthly Fee INV') {
              temp['parkingFee'] += invoiceRecord.inclusive;
            }
            temp['total'] += invoiceRecord.inclusive;
          }
        }

        temp['deposit'] = helper.formatMoney(temp['deposit']);
        temp['estbFee'] = helper.formatMoney(temp['estbFee']);
        temp['parkingFee'] = helper.formatMoney(temp['parkingFee']);
        temp['total'] = helper.formatMoney(temp['total']);

        let customerID = k.customerID;
        temp['_customer'] = this.pageCustomer.find(j => j.id === customerID) || {};
        temp['isCompany'] = temp['_customer'].isCompany;
        let carparkID = k.carparkID;
        temp['_carpark'] = this.pageCarpark.find(j => j.id === carparkID) || {};
        temp['_license'] = this.pageLicense.find(j => j.customerID === customerID && j.carparkID === carparkID) || {};
        temp['licenseID'] = temp['_license'].id;
        // temp['_season'] = this.pageSeason.find(j => j.id === invoiceLeaseDetail.seasonID);
        temp['orNum'] = helper.plORNum(temp.receiptNum, temp.carparkID);
        temp['orDate'] = helper.formatDate(temp.createDate);
        temp['paymentType'] = temp['paymentType']

        temp['parkinglicense'] = helper.plFormPLNum(temp['_license'].licenseOperatorNum, carparkID);
        temp['customer'] = temp['_customer']['name'];
        // temp['season'] = temp['_season']['name'];
        // temp['seasonTenant'] = temp['_season']['isTenant'] ? 'T' : 'NT';

        result.push(k);
      }

      this.$refs['pageTable'].setTableData(result);
      this.showExportCSV = true;
    },

    onFilterCarparkChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setTableData(this.pageReport = null);
      this.loadSeason();
    },
    onFilterDateChange(dataIndex) {
      this.showExportCSV = false;
      this.$refs['pageTable'].setTableData(this.pageReport = null);
      this.loadCollection();
    },

    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'paymethodID') {
        let paymentMethod = formData[formParameter.key];
        if(paymentMethod === this.paymentMethodIDGiro) {
          // giro
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = false;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = false;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = true;
        } else if(paymentMethod === this.paymentMethodIDCheque) {
          // cheque
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = false;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = false;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = false;
        } else { 
          // cash?
          this.PAYMENT_PARAM_MAP['giroTransactionCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['giroTransactionDate'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeBankCode'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeNumber'].form_hide = true;
          this.PAYMENT_PARAM_MAP['chequeDate'].form_hide = true;
        }
      } else if(formParameter.key === 'staffID') {
        let staff = helper.inputSelectFindOption(this.PAYMENT_PARAM_MAP['staffID'], formData['staffID'])
        formData['staffNo'] = staff['personnelCode'];
      }
    },
    onCSVButtonClick() {
      let carpark = this.pageCarpark.find(k => helper.compareID(k.id, this.$refs['carparkFilter'].filterValue))
      let startDate = this.$refs['dateRangeFilter'].filterDateStart;
      let endDate = this.$refs['dateRangeFilter'].filterDateEnd;

      var header = [];
      if(carpark) {
        header.push('Car Park Code: ' + carpark.carparkCode)
        header.push('Car Park: ' + carpark.name)
      }
      header.push('REPORT : SEASON PARKING COLLECTION FOR THE MONTH - ' + (startDate.month() + 1) + '/' + startDate.year())
      
      printCSV('#jt-table', `Report Car Park Collection ${(startDate.month() + 1) + '/' + startDate.year()}`, header);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Report/PageReportCarParkCollection.vue